<template>
	<div>
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col">
	            <div class="custom-header-banner">
	              <img src="../static/eematico-toys-banner.jpg" alt="eematico toys" class="fluid-img">
	              <div class="custom-banner-text">
					<h1>TOYS TO REMEMBER</h1>
					<p>we will craft toys with the belief that <span>playing</span> is learning we will craft toys that <span>make</span> the most of <span>playing</span> and make more time for it</p>
					<p>toys to <span>make</span>, toys to <span>play</span> with, toys to <span>learn</span> with toys for the <span>hands</span>, toys for the <span>mind</span>, toys for the <span>heart</span> toys to <span>remember</span></p>
					<h2><span>we will craft eematico toys.</span></h2>
					<p>take a look at our first models and if you like them contact us to purchase some of these pre-launch products…</p>

	                <span @click="scrollToProducts" class="custom-arrow-down"> </span>
	              </div>
	            </div>

	        </v-col>
	      </v-row>
	    </v-container>
	    <v-container class="custom-padding-container">
	      <v-col cols="12" class="custom-padding-col">
	        <v-row>
	          <div class="custom-items-container">
	            <div class="custom-item-top">
	              <h2>learn new stuff</h2>
	              <img src="../static/eematico-toys-jucarii-invatare.png" alt="eematico toys jucarii invatare">
	              <p>our toys are crafted to provide as many learning opportunities as possible for your child</p>
	            </div>
	            <div class="custom-item-top">
	              <h2>challenge your child</h2>
	              <img src="../static/eematico-toys-jucarii-provocari.png" alt="eematico toys jucarii provocări">
	              <p>a good deal of the adventure is for your child to assemble it; so we craft it, your child builds it</p>
	            </div>
	            <div class="custom-item-top">
	              <h2>parents, join the fun</h2>
	              <img src="../static/eematico-toys-jucarii-distractie.png" alt="eematico toys jucarii distractie">
	              <p>you may even join your child in discovering his toy</p>
	            </div>
	            <div class="custom-item-top">
	              <h2>make it unique</h2>
	              <img src="../static/eematico-toys-jucarii-oportunitati.png" alt="eematico toys jucarii oportunități">
	              <p>our carefully designed and made toys provide your child with opportunities for customisations: drawing, colours and even shaping the characters</p>
	            </div>
	            <div class="custom-item-top last-item">
	              <h2>only gender free toys</h2>
	              <img src="../static/eematico-toys-jucarii-invatare.png" alt="eematico toys jucarii invatare">
	              <p>our toys are not for girls or for boys; they are toys for children to learn unbiased.</p>
	            </div>            
	          </div>  
	        </v-row>                            
	      </v-col>

	    </v-container>
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col custom-products-container">
	          <div class="custom-border"></div>
	          <h2 class="custom-subtitle" id="products">OUR PRODUCTS</h2>
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-automatorul.jpg" class="fluid-img" alt="eematico toys jucarii automatorul"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Automata (assembly kit)</h2>
	                <p>The automata is a toy that uses gears to animate characters. The camshaft and the cogwheels, inspired from devices used in modern combustion engines, determine the movement of the two characters, that challenge your children to use their creativity in order to customise them. It has lots of cool info on it to guide and help your child learn about neat stuff.</p>
	                <p>Comes with glue & sand-paper. Wits&intuition (and maybe you) will help your child assemble it or they can watch our wonderful instructions video</p>
	                <span>Age group: <strong>&gt; years old</strong><br/> Price: <strong> 17 €</strong></span>

	                <v-btn class="custom-button-form" @click.prevent="goToForm('Automaton (kit de asamblare)')" :height="'auto'">I’M INTERESTED</v-btn>                
	              </div>
	            </v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12" sm="6" class="custom-order2">
	              <div class="products-info">
	                <h2 class="title2">Carousel (assembly kit)</h2>
	                <p>The Carousel is an assemble-it-yourself entertaining toy. It is a good showcase for the concept of inertia: your child winds it and then watches it unwind and rewind for quite a long time. What do they think the number of character does to the duration of the movement? Hint: Inertia is about mass… But the Carousel has another playful side to it! Children may use the marble provided to reach the holes through the cutout labyrinth…</p>
	                <p>Comes with glue, sandpaper, string & ball for the labyrinth. Wits&intuition (and maybe you) will help your child assemble it or they can watch our wonderful instructions video .</p>
	                <span>Age group: <strong>&gt; years old</strong><br/> Price: <strong> 15 €</strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Carusel (kit de asamblare)')" :height="'auto'">I’M INTERESTED</v-btn>                    
	              </div>
	            </v-col>
	            <v-col cols="12" sm="6" class="custom-order">
	              <img src="../static/eematico-toys-jucarii-caruselul.jpg" class="fluid-img" alt="eematico toys jucarii caruselul"/>
	            </v-col>            
	          </v-row> 
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-geo-puzzle.jpg" class="fluid-img" alt="eematico toys jucarii geo-puzzle"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Geo—puzzle</h2>
	                <p>Does your child like geometry? Do they know what tessellation is? Do they like jigsaw puzzles? If the answer is yes on all three questions than they will love this beautiful toy and work of art. If they do not like (or know what is) geometry, they will after trying our puzzle and learning about tessellations. If they do not know what tesselations are, they will understand with this neat puzzle and even learn how to make new ones. If they do not like puzzles, the satisfaction this one gives you will make sure that they will.</p>
	                <p>Has 25/46/36 pieces.<br/>
					Wits&intuition (and maybe you) will help your child assemble it.</p>
	                <span>Age group: <strong>&gt; 5 years old</strong><br/>Price: <strong>  17/19/21 € </strong></span>
	                 <v-btn class="custom-button-form" @click.prevent="goToForm('Geo—puzzle')" :height="'auto'">I’M INTERESTED</v-btn>                  
	              </div>
	            </v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12" sm="6" class="custom-order2">
	              <div class="products-info">
	                <h2 class="title2">StampPress (assembly kit)</h2>
	                <p>All children love stamps. But wait till they get their hands on the stamp press. It’s a simple assemble-it-yourself toy that can be set up in about 20 minutes. But it will provide countless opportunities to create new stamps and print them on many surfaces. For older children it is a great tool to learn a few things about second class levers (and levers in general). Younger children will pick up stuff for later in school just by playing with it.</p>
	                <p>Wits&intuition (and maybe you) will help your child assemble it or they can watch our wonderful instructions video. Comes with glue, bolt&nut, spigot, stamp material and a few stamp surfaces.</p>
	                <span>Age group: <strong>&gt; 3 years old</strong><br/> Price: <strong> 14.9 €</strong></span>
	               <v-btn class="custom-button-form" @click.prevent="goToForm('Presa de ștampile (kit de asamblare)')" :height="'auto'">I’M INTERESTED</v-btn>        
	              </div>
	            </v-col>
	            <v-col cols="12" sm="6" class="custom-order">
	              <img src="../static/eematico-toys-jucarii-presa-de-stampile.jpg" class="fluid-img" alt="eematico toys jucarii presa de stampile"/>
	            </v-col>            
	          </v-row>   
	          <v-row>
	            <v-col cols="12" sm="6">
	              <img src="../static/eematico-toys-jucarii-rubo-car.jpg" class="fluid-img" alt="eematico toys jucarii rubo car"/>
	            </v-col>
	            <v-col cols="12" sm="6">
	              <div class="products-info">
	                <h2 class="title1">Rubo car (assembly kit)</h2>
	                <p>Everybody loves cars, girls, boys, women, men and even people who only go by bike. They are a symbol of freedom and being able to transcend your boundaries. So a toy car is a must. Ours is assemble-it-yourself and leaves plenty of room for imagination by being an open invitation for your child to make it their own by using plenty of colours to customise it. It’s great fun because it has an engine. It’s rubber band powered so it can easily be replaced once it tears down (unlike a real car). It also has rubber tyres, and will teach your child a few things about cars, motion physics and geometry.</p>
	                <p>Wits&intuition (and maybe you) will help your child assemble it or they can watch our wonderful instructions video. Comes with glue, bolts&nuts and a few rubber bands</p>
	                <span>Age group: <strong>&gt; 5 years old</strong><br/> Price: <strong>  16 €  </strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('RuboCar')" :height="'auto'">I’M INTERESTED</v-btn>            
	              </div>
	            </v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12" sm="6" class="custom-order2">
	              <div class="products-info">
	                <h2 class="title2">Sticks & Bolts Building Kit</h2>
	                <p>Wood and building are connected together since the beginning of time. Wood and metal have been a cornerstone to building since many centuries. So this wonderful set of modular wood pieces and screws will lay the foundations of many building adventures, providing your child with lots of assembly combinations to let their imagination and dexterity roam free. And if they don’t like their creation they can always start over. As many times as they like …</p>
	                <p>Wits&intuition (and maybe you) will help your child assemble it. Comes with 24 fir wooden parts and enough nuts and bolts.</p>
	                <span>Age group: <strong>&gt; 5 years old</strong><br/> Price: <strong> 18 € </strong></span>
	                <v-btn class="custom-button-form" @click.prevent="goToForm('Kitul de construire')" :height="'auto'">SUNT INTERESAT</v-btn>             
	              </div>
	            </v-col>
	            <v-col cols="12" sm="6" class="custom-order">
	              <img src="../static/eematico-toys-kit-de-construire.jpg" class="fluid-img" alt="eematico toys jucarii kit de construire"/>
	            </v-col>            
	          </v-row> 
	        </v-col>
	      </v-row>    
	    </v-container>
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col">
	          <div class="custom-border"></div>
	          <h2 class="custom-subtitle">ABOUT-US</h2>
	          <div class="custom-about-us">
	            <p>We believe that playing is the main learning mechanism in nature and we use this concept to create relevant, innovative, hands-on learning experiences for children. So we develop and deliver to children educational programs and materials that make learning child play. We’ve been doing that for almost 3 years, creating for more than 2500 children, more than 350 hours of educational content, 600 activities and as many educational materials.</p>

	            <p>Since our mission is to make our learning products available to as many children as possible we decided to use our experience and energy to develop our own range of learning (educational) toys. eematico Toys. Based on our experience in designing and making educational materials that have been thoroughly tested by hundreds of children for years, we develop toys to make the most of playing as a developmental tool for children.</p>
	          </div>
	          <img src="../static/eematico-toys-team.jpg" alt="eematico toys team" class="fluid-img">
	        </v-col>
	      </v-row>
	    </v-container>
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col">
	          <div class="custom-border"></div>
	          <h2 class="custom-subtitle">CONTACT US</h2>
	          <v-form ref="form" v-model="valid" :lazy-validation="lazy" id="contact-form">
	          <v-row>
	            <v-col md="12" cols="12">
	              <v-text-field v-model="name" :counter="50" :rules="nameRules" label="Full Name*" required></v-text-field>
	              <v-text-field v-model="surName" label="Surname*" class="custom-surname"></v-text-field>
	            </v-col>
	            <v-col sm="6" cols="12">
	              <v-text-field v-model="email" :rules="emailRules" label="E-mail*" required></v-text-field>
	            </v-col>
	            <v-col sm="6" cols="12">
	              <v-text-field v-model="phone" :rules="phoneRules" label="Telephone Number*" required></v-text-field>
	            </v-col>
	            <v-col sm="12" cols="12">
	                <p>I'm interested in*:</p>
	                <v-row>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Automaton (kit de asamblare)" label="Automaton" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Carusel (kit de asamblare)" label="Carousel" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                </v-row>
	                <v-row>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Geo—puzzle" label="Geo—puzzle" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="Presa de ștampile (kit de asamblare)" label="StampPress (assembly kit)" required :hide-details="true"></v-checkbox>
	                  </v-col>
	                </v-row> 
	                <v-row>
	                  <v-col sm="6" cols="12">
	                    <v-checkbox v-model="product" :rules="productRules" value="RuboCar" label="Rubo car (assembly kit)" required :hide-details="desktopHide"></v-checkbox>
	                  </v-col>
	                  <v-col sm="6" cols="12">
	                     <v-checkbox v-model="product" :rules="productRules" value="Kitul de construire" label="Sticks & Bolts Building Kit" required :hide-details="mobileHide"></v-checkbox>  
	                  </v-col>
	                </v-row> 	                
	            </v-col>            
	          </v-row>
	          <v-row cols="12">
	            <v-col cols="12">
	               <v-textarea solo name="input-7-4" v-model="message" :counter="500" :rules="messageRules" label="Mesaj*" ></v-textarea>
	            </v-col>
	          </v-row>
	            <v-col md="12" cols="12">
	              <v-text-field v-model="voucherCode" label="Cod Voucher"></v-text-field>
	            </v-col>          
	          <v-row>
	            <v-col cols="12">
	              <v-checkbox v-model="checkbox" :rules="[v => !!v || 'You must agree terms and condition to continue!']" label="Do you agree with the Terms and Conditions?*" required></v-checkbox>
	            </v-col>
	          </v-row>
	          <v-row>
	          	<v-col cols="12">
					<p>Disclaimer:</p>

					<p>We are at the start of our toy manufacturing adventure. We therefore only able to provide, upon request, a limited number of toys. We will do our best to make sure that the toys reach you as soon as possible, but that could however, in some cases, take a bit since we do not keep a large stock. For now, payment can only be made cash on delivery, but we are working on making more payment options available. Delivery is not included, but should you like one of our toys we can provide you with a quotation. For larger orders (above 150 Euro) delivery in the EU is included. Although we invest a lot of time in quality, since most of our toys are assembly kits, we only offer a limited warranty depending on specific circumstances.</p>
	          	</v-col>
	          </v-row>
	          <v-row>
	            <v-col cols="12">
	                <button class="v-btn custom-button-form" @click.prevent="validate">Trimite</button>
	            </v-col>
	          </v-row>
	          <v-row>
	          	<v-col cols="12">
					<v-alert type="success" v-if="showMsgProduct">
						The request was successfully sent!
					</v-alert>   
					<v-alert type="error" v-if="errorSubmit">
						There was an error, please try again!
					</v-alert> 					
	          	</v-col>
	          </v-row>
	          </v-form>                 
	        </v-col>
	      </v-row>
	    </v-container>    
	    <v-container class="custom-padding-container">
	      <v-row>
	        <v-col cols="12" class="custom-padding-col text-center">
	          <div class="custom-border"></div>
	          <h2 class="custom-subtitle">eematico PROGRAMS</h2>
	          <p class="custom-para-programe">Besides making toys, and in fact before making toys, we started 3 years ago by creating and delivering play based, hands-on, innovative educational programs for children 3-6 & 7-12 years old children. Come check them out on our education programs website.</p>
	          <a class="v-btn custom-button-programe" target="_blank" rel="noopener" href="http://eematico.org/">SEE COURSES</a>
	        </v-col>    
	      </v-row>
	    </v-container>		
	</div>
</template>
<script>
  export default{
    data(){
      return{
        valid: true,
        name: '',
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 50) || 'Name must be less than 50 characters',
        ],
        surName:'',
        phone:'',
        phoneRules:[
          v => !!v || 'Phone is required',
        ],
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        product:[],
        productRules:[
          v => v.length > 0  || "At least one item should be selected",
        ],
        message:'',
        messageRules:[
          v => !!v || 'Message is required',
          v => (v && v.length <= 500) || 'Name must be less than 500 characters',
        ],
        voucherCode:'',
        checkbox: false,
        lazy: false,
        validNewsletter:true,
        emailNewsletter:'',
        emailRulesNewsletter:[ v => !!v || 'E-mail is required',v => /.+@.+\..+/.test(v) || 'E-mail must be valid',],
        fab: false,
        desktopHide:  window.innerWidth > 600 ? false : true,
        mobileHide:   window.innerWidth < 600 ? false : true,
        showMsgProduct:false,
        errorSubmit:false,        
          }
    },
    mounted(){
    	this.$i18n.locale = 'en';
    },
    beforeDestroy(){
       	this.$i18n.locale = 'ro';	
    },
    methods: {
    	scrollToProducts(){
			document.querySelector('#products').scrollIntoView({behavior: 'smooth'});
    	},
    	goToForm(value){
    		document.querySelector('#contact-form').scrollIntoView({behavior: 'smooth'});
    		this.product.push(value);
    	},
        validate() {
            if (this.$refs.form.validate()){
              if(this.surName===''){
              	this.errorSubmit=false;
              	var _this  = this;
                this.$axios.post('http://toys-new.eematico.org/product.php', {
                  name: this.name,
                  phone: this.phone,
                  email: this.email,
                  product: this.product,
                  message:this.message,
                  voucherCode: this.voucherCode,
                  TermsAndCondition: this.checkbox,
                  eematicoProduct: true
                })
                .then(function (response) {
                  if(response.data===1){
						_this.showMsgProduct = true;
						_this.$refs.form.reset();
						_this.name =""
						_this.phone="";
						_this.email="";
						_this.product=[];
						_this.message='';
						_this.voucherCode='';
						_this.checkbox=false;                 
                  }else{
                    _this.errorSubmit = true;
						_this.showMsgProduct = true;
						_this.$refs.form.reset();
						_this.name =""
						_this.phone="";
						_this.email="";
						_this.product=[];
						_this.message='';
						_this.voucherCode='';
						_this.checkbox=false;                        
                  }
                  
                })
              }else{
                this.errorSubmit = true;
				this.showMsgProduct = true;
				this.name =""
				this.phone="";
				this.email="";
				this.product=[];
				this.message='';
				this.voucherCode='';
				this.checkbox=false;                    
              }
           }	
          },

    }
  }
</script>